module.exports = __webpack_public_path__ + "static/media/clinic_marker.65bafcd6.png";